import { Storage } from '@meemo/lamp'

const storage = new Storage('backstage', 'localStorage', 'nxkb')

export default storage
